import { Field, Image, ImageField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import styles from './ImageComponent.module.css';

type ImageComponentProps = ComponentProps & {
	fields: {
		Image: Field<ImageField>;
	};
};

export default withDatasourceCheck()<ImageComponentProps>(ImageComponent);
function ImageComponent(props: ImageComponentProps): JSX.Element {
	const image = props.fields.Image?.value as {
		alt: string;
		height: string;
		src: string;
		width: string;
	};

	const mediaWithModifiedSrc = {
		...image,
		src: process.env.PUBLIC_URL && image?.src ? image.src.replace(/^https?:\/\/[^\/]+/, process.env.PUBLIC_URL) : image?.src,
	};

	return (
		<div className={styles.imageContainer} data-display-pdf-download>
			<Image media={mediaWithModifiedSrc} className={styles.image} />
		</div>
	);
}
